export default {"src":"/_next/static/media/goomy.0845fb7c.gif","height":192,"width":192,"blurWidth":0,"blurHeight":0};